import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { resetALL } from "../../../../../../../.globals/redux/actions";
import { endpoints } from "../../../../../../../core/defaultValues";
import { clientQuery } from "../../../../../../../core/data/GraphQLApi";
import { ExceptionManager } from "../../../../../../../core/logManager";

const INIT_STATE = {
    open: false,
    loading: false,
    statuses: [],
    loadingStatuses: false,
    workOrderTypes: [],
    loadingWorkOrderTypes: false,
};

const workOrdersSearchWorkOrderStatuses = createAsyncThunk(
    "workOrders/trackerTab/advancedFilters/searchWorkOrderStatuses",
    async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                workOrdersSearchWorkOrderStatuses.query,
                {
                    conditions,
                    sort: {
                        field: "name",
                        order: "ASC"
                    },
                    limit,
                    offset,
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data || { items: [], total: 0 };
        } catch (exc) {
            ExceptionManager(exc, route, "searchWorkOrderStatuses");
            return rejectWithValue(exc);
        }
    }
);

const workOrdersSettingsSearchWorkOrderTypes = createAsyncThunk(
    "workOrders/trackerTab/advancedFilters/searchWorkOrderTypes",
    async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
        try {
            const response = await clientQuery(
                workOrdersSettingsSearchWorkOrderTypes.query,
                {
                    conditions,
                    sort: {
                        field: "name",
                        order: "ASC"
                    },
                    limit,
                    offset,
                },
                endpoints.GRAPHQL_GENERAL_V2
            );

            return response?.data || { items: [], total: 0 };
        } catch (exc) {
            ExceptionManager(exc, route, "searchWorkOrderTypes");
            return rejectWithValue(exc);
        }
    }
);

workOrdersSettingsSearchWorkOrderTypes.query = `
    query ($conditions: [WorkOrderTypeSearchInput], $sort: [WorkOrderTypeSortInput], $limit: Int, $offset: Int) {
        data: searchWorkOrderTypes(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
            total
            items {
                id
                name
            }
        }
    }
`;

workOrdersSearchWorkOrderStatuses.query = `
    query ($conditions: [WorkOrderStatusSearchInput], $sort: [WorkOrderStatusSortInput], $limit: Int, $offset: Int) {
        data: searchWorkOrderStatuses(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
            total
            items {
                id
                name
            }
        }
    }
`;

export { workOrdersSearchWorkOrderStatuses, workOrdersSettingsSearchWorkOrderTypes };

//Slice
const workOrdersWorkOrderTabAdvancedFiltersRedux = createSlice({
    name: "workOrders/workOrderTab/advancedFilters",
    initialState: INIT_STATE,
    reducers: {
        reset(state, action) {
            return action.payload ? { ...state, ...action.payload } : INIT_STATE;
        },
        openModalAdvancedFilters: (state, action) => {
            state.open = action.payload.open;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetALL, () => INIT_STATE);

        //workOrdersSearchWorkOrderStatuses
        builder.addCase(workOrdersSearchWorkOrderStatuses.pending, (state) => {
            state.loadingStatuses = true;
        });
        builder.addCase(workOrdersSearchWorkOrderStatuses.fulfilled, (state, action) => {
            state.loadingStatuses = false;
            state.statuses = action.payload.items;
        });
        builder.addCase(workOrdersSearchWorkOrderStatuses.rejected, (state, action) => {
            state.loadingStatuses = false;
            state.error = action.payload;
        });

        //workOrdersSettingsSearchWorkOrderTypes
        builder.addCase(workOrdersSettingsSearchWorkOrderTypes.pending, (state) => {
            state.loadingWorkOrderTypes = true;
        });
        builder.addCase(workOrdersSettingsSearchWorkOrderTypes.fulfilled, (state, action) => {
            state.loadingWorkOrderTypes = false;
            state.workOrderTypes = action.payload.items;
        });
        builder.addCase(workOrdersSettingsSearchWorkOrderTypes.rejected, (state, action) => {
            state.loadingWorkOrderTypes = false;
            state.error = action.payload;
        });
    },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = workOrdersWorkOrderTabAdvancedFiltersRedux;

// Extract and export each action creator by name
export const { openModalAdvancedFilters, reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;
